/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Already_MemberInputs */

const es_co2_error_email_already_member = /** @type {(inputs: Error_Email_Already_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este correo ya pertenece a un miembro de la empresa.`)
};

/**

* @param {Error_Email_Already_MemberInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_email_already_member = /** @type {((inputs?: Error_Email_Already_MemberInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Already_MemberInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_email_already_member(inputs)
});